import moment from 'moment-timezone';

/**
 * Computes the end of the configured scheduling window by adding the
 * scheduling window to the flow's start date (scheduled_for).
 *
 * @param scheduledForRaw  Raw ISO string from Firestore (scheduled_for)
 * @param schedulingWindow Number of units in the scheduling window
 * @param scheduleOverUnit Unit string e.g. "days", "weeks", "months"
 * @param timezone         Org timezone for formatting
 * @returns Formatted date string, or '-' if data is missing
 */
export const getScheduleWindowEndDate = (
  scheduledForRaw: string,
  schedulingWindow: number,
  scheduleOverUnit: string,
  timezone: string
): string => {
  if (!scheduledForRaw || !schedulingWindow || !scheduleOverUnit) return '-';

  const unit = scheduleOverUnit.toLowerCase() as moment.DurationInputArg2;
  const lastDate = moment(scheduledForRaw).add(schedulingWindow, unit);
  if (!lastDate.isValid()) return '-';

  return lastDate.tz(timezone).format('MMM D, YYYY h:mm A z');
};
